import * as React from "react";
import CircularProgress from "@mui/material/CircularProgress";
import "./Loading.scss";

export default function Loading() {
  return (
    <div>
      <div className="frame-circularProgress">
        <CircularProgress />
      </div>
      <div>
        <h3>Loading Data...</h3>
      </div>
    </div>
  );
}
